/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientDetails } from '../../models/client-details';

export interface ApiTapioGetClientInfoGet$Json$Params {
  CLIENT_ID?: string;
  Authorization?: string;
}

export function apiTapioGetClientInfoGet$Json(http: HttpClient, rootUrl: string, params?: ApiTapioGetClientInfoGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientDetails>> {
  const rb = new RequestBuilder(rootUrl, apiTapioGetClientInfoGet$Json.PATH, 'get');
  if (params) {
    rb.query('CLIENT_ID', params.CLIENT_ID, {});
    rb.header('Authorization', params.Authorization, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientDetails>;
    })
  );
}

apiTapioGetClientInfoGet$Json.PATH = '/api/Tapio/GetClientInfo';
